import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { MissingBirthdate, ParticipantsCategory } from 'types/typescript'
import { FindMissingBirthdatesFromComparison } from './types/findMissingBirthdatesFromComparison.types'
import {
  findBirthdateIndexInCategoryList,
  findMissingBirthdateInAllCategories
} from './'

export const findMissingBirthdatesFromComparison: FindMissingBirthdatesFromComparison = (
  prevBirthdates,
  nextBirthdates
) => {
  if (prevBirthdates && nextBirthdates) {
    const birthdates = JSON.parse(JSON.stringify(nextBirthdates))

    return PARTICIPANTS_CATEGORIES.reduce<MissingBirthdate[]>((missingBirthdatesList, category: ParticipantsCategory) => {
      prevBirthdates[category].forEach((prevBirthdate, birthdateIndex: number) => {
        const checkedBirthdate = findBirthdateIndexInCategoryList(prevBirthdate, birthdates[category])

        if (checkedBirthdate === -1) {
          const missingBirthdate = findMissingBirthdateInAllCategories({ birthdate: prevBirthdate, source: category }, birthdates, category) as Writeable<MissingBirthdate>

          if (missingBirthdate) {
            const categoryBirthdatesList = birthdates[missingBirthdate.destination!]

            missingBirthdate.position = birthdateIndex + 1
            missingBirthdate.source = category
            missingBirthdatesList.push(missingBirthdate)

            if (
              Array.isArray(categoryBirthdatesList) &&
              (categoryBirthdatesList.length - 1) >= missingBirthdate.index!
            ) {
              birthdates[missingBirthdate.destination!].splice(missingBirthdate.index, 1)
            }
          }
        }
      })
      return missingBirthdatesList
    }, [])
  }

  return []
}
